import HardRedirect from 'app/components/router/HardRedirect';
import { useHistoryLocation } from 'app/components/router/History';
import { replaceDomain } from 'app/utils/routes';
import React from 'react';

const DomainRedirect: React.FC<{ domain: string }> = ({ children, domain }) => {
  const location = useHistoryLocation();
  return (
    location.hostname !== domain ? (
      <HardRedirect href={replaceDomain(domain, location)} />
    ) : (
      // Use `as` because the current type definition for FC is inconsitent with React 16, which
      // allows returning non-elements now.
      children as React.ReactElement<any>
    )
  );
};

export default DomainRedirect;
